module.exports = __webpack_public_path__ + "static/media/arrow-down-solid.3e9c517e.svg";